// O cartão "WhatsApp não oficial" na escolha de provedor da caixa de WhatsApp
// (channels/Whatsapp.vue do core, por patch). Só aparece com o recurso
// whatsapp_nao_oficial da empresa ligado.
import { computed } from 'vue';
import { useRecursos } from '../nexus/recursos';
import messages from '../nexus/i18n';

export const PROVEDOR_NAO_OFICIAL = 'nexus_wa';

export const useProvedorNaoOficial = () => {
  const recursos = useRecursos();
  const textos = messages.pt_BR.NEUXS_NEXUS.WHATSAPP;

  return computed(() =>
    recursos.value?.whatsapp
      ? [
          {
            key: PROVEDOR_NAO_OFICIAL,
            title: textos.CARTAO_TITULO,
            description: textos.CARTAO_DESCRICAO,
            icon: 'i-woot-whatsapp',
          },
        ]
      : []
  );
};
